import React from "react";
import { RoundedChecklistIcon } from "../icons";
import { MotionModal, ModalCloseButton } from "../motion";
const SuccessModal = ({ isOpen, onClose, title, message }) => {
  return (
    <MotionModal show={isOpen} onClose={onClose} maxWidthClassName="tw:max-w-[450px]">
      <ModalCloseButton onClick={onClose} />

      {/* Modal Content */}
      <div className="tw:px-8 tw:py-12 tw:text-center">
        {/* Success Icon */}
        <div className="tw:mb-6 tw:flex tw:justify-center">
          <div className="tw:w-12 tw:h-12 tw:rounded-full tw:flex tw:items-center tw:justify-center">
            <RoundedChecklistIcon color="#3CAEA3" aria-label="Success" size={46} />
          </div>
        </div>

        {/* Title */}
        <div className="tw:text-[18px] tw:font-semibold tw:leading-[26px] tw:text-[#282828] tw:font-hanken-grotesk">
          {title}
        </div>

        {/* Message */}
        <div className="tw:text-[14px] tw:leading-[22px] tw:text-[#6b6b6b] tw:font-hanken-grotesk">
          {message}
        </div>
      </div>
    </MotionModal>
  );
};

export default SuccessModal;
